import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/free-regular-svg-icons";

const ActivityLog = ({ activityData }) => {
  const formatDate = (dateString) => {
    if (!dateString) return "Unknown date";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "Invalid date";
    const datePart = date.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
    });
    const timePart = date.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
    });
    return `${datePart} | ${timePart}`;
  };

  if (!activityData) {
    return null;
  }

  const dateField = activityData.created_at || activityData.date_created;
  const details = activityData.details || "No details";

  return (
    <div className="activity-log-container activity-log-item">
      <div className="activity-log-header">
        <div className="activity-log-label-row">
          <FontAwesomeIcon icon={faCircle} className="activity-log-icon" />
          <span className="activity-log-label">Activity</span>
        </div>
        <div className="activity-log-timestamp">{formatDate(dateField)}</div>
      </div>
      <div className="activity-log-content">
        <span className="activity-log-details">{details}</span>
      </div>
    </div>
  );
};

export default ActivityLog;
